<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>

    <div class="hearder my_pd_header" :style="tabbar[active].background">
<!--      <div class="header_bg"></div>-->
      <div class="logo">
        <img src="@/assets/logo_bai.png" alt="">
      </div>
      <div class="right_box">
        <div class="head_ul">
          <div
            class="head_li "
            :class="{'head_li_active':index==active}"
            v-for="(item,index) in tabbar"
            :key="index"
            @click="to_link(item._link)"
          >
            <span
              class="text_haidden" :title="item.name">{{item.name}}</span>
            <ul ref="childrenList" v-if="item.children" class="children">
              <li
                :class="{'activeColor': activeChild == i.id}"
                v-for="i in item.children"
                @click="changeChild(i)"
              >{{i.name}}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <ContactUS/>
  </div>
</template>

<script>
import ContactUS from './components/ContactUS'
export default {
  name: "App",
  data() {
    return {
      active: 1, //初始化 默认首页的id
      tabbar: [
        { id: 0, name: "区块链", _link: "/qukuailian", background: "" },
        {
          id: 1,
          name: "数字藏品",
          _link: "/cangpin",
          background: {
            "background-image": 'url("./assets/cangpin/cangpin_beijing.png")',
          },
        },
        { id: 2, name: "溯源", _link: "/suyuan", background: "" },
        { id: 3, name: "技术优势", _link: "/jishuyoushi", background: "" },
        {
          id: 4,
          name: "案例",
          _link: "/anli",
          background: "",
          children: [
            {id: 4.1, name: "数字藏品", _link: "/cangpin", background: ""},
            {id: 4.2, name: "溯源", _link: "/suyuan", background: ""},
            {id: 4.3, name: "同构链", _link: "/tonggou", background: ""},
            {id: 4.4, name: "债券", _link: "/zhaiquan", background: ""}
          ]
        },
        { id: 5, name: "优质服务", _link: "/youzhifuwu", background: "" },
        { id: 6, name: "ULAM荣誉", _link: "/ulamrongyu", background: "" },
        { id: 7, name: "关于我们", _link: "/guanyuwomen", background: "" },
      ],
      activeChild: 1,
      onLine: navigator.onLine, // 初始化网络在线状态
    };
  },
  components: {
    ContactUS
  },
  watch: {
    $route(to, from) {
      this.to_active(to.path); //解决返回时图标问题
    },
  },
  created () {
    window.addEventListener('scroll', (ev) => {
      let top = document.documentElement.scrollTop
      let header = document.querySelector('.hearder')
      let children = document.querySelector('.children')
      if(top >= 500){
        header.classList.add('header_filter_bg')
        children.classList.add('childrenTabBar_bg')
      }
      if(top < 500 ){
        header.classList.remove('header_filter_bg')
        children.classList.add('childrenTabBar_bg')
      }
    })
  },
  mounted() {
    this.to_active(this.$route.path); //解决刷新底部图标问题

    window.addEventListener("online", this.updateOnlineStatus);
    window.addEventListener("offline", this.updateOnlineStatus);
  },

  beforeDestroy() {
    window.removeEventListener("online", this.updateOnlineStatus);
    window.removeEventListener("offline", this.updateOnlineStatus);
  },

  methods: {
    to_link(_link) {
      if(_link === '/anli') return
      this.$router.push(_link);
    },
    to_active(path) {
      this.tabbar.map((item, index) => {
        item._link == path ? (this.active = index) : false;
      });

      // let FindItem = this.tabbar.find((item) => item.id == this.active);
      // this.to_link(FindItem._link);
    },
    //更新网络状态
    updateOnlineStatus(e) {
      const { type } = e;
      this.onLine = type === "online";
      if (this.onLine) {
        this.$toast({ position: "bottom", message: "网络已恢复" });
      } else {
        this.$toast({ position: "bottom", message: "网络异常,请检查网络设置" });
      }
    },
    // 子项切换
    changeChild(obj) {
      this.activeChild = obj.id
      this.$router.push(obj._link)
      this.active = 4
    }
  },
};
</script>

<style lang="less">
#app {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100vh;
  position: relative;
  background-color: #000;

  .my_pd_header {
    width: 100%;
    padding: 0 10%;
    box-sizing: border-box;
  }

  .my_pd_content {
    width: 100%;
    padding: 0 10%;
    box-sizing: border-box;
  }

  .text_haidden {
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden; //溢出内容隐藏
    text-overflow: ellipsis; //文本溢出部分用省略号表示
    display: -webkit-box; //特别显示模式
    -webkit-line-clamp: 2; //行数
    line-clamp: 2;
    -webkit-box-orient: vertical; //盒子中内容竖直排列
  }

  .hearder {
    width: 100%;
    height: 70px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10000;
    color: #fff;
    .logo {
      width: 40px;
      height: 40px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .right_box {
      height: 100%;
      .head_ul {
        display: flex;
        height: 100%;
        .head_li {
          text-align: center !important;
          height: 100%;
          width: 90px;
          display: flex;
          align-items: center;
          font-weight: 500;
          color: #ffffff;
          font-size: 12px;
          text-align: center;
          padding: 0 6px;
          box-sizing: border-box;
          cursor: pointer;
          position: relative;
          &:hover .children{
            display: block;
          }
          span{
            width: 100%;
          }
          .bg{
            height: 100px;

            filter: blur(px);
          }
          .children{
            //background-color: #00FFFF;
            display: none;
            text-align: center;
            position: absolute;
            top: 55px;
            left: 0;
            border-radius: 5px;
            //overflow: hidden;
            li{
              width: 90px;
              height: 45px;
              line-height: 45px;
              color: #FFFFFF;
              border-radius: 5px;
              &:hover{
                color: #83ffe1;
                box-sizing: border-box;
                border: 1px solid #83ffe1;
                border-radius: 5px;
              }
            }
          }
        }

        .head_li_active {
          color: #83ffe1;
          border-top: 2px solid #83ffe1;
          border-radius: 2px;
          padding: 0 10px;
          box-sizing: border-box;
        }
      }
    }
  }
  .activeColor {
    color: #83ffe1 !important;
  }
  .header_filter_bg{
    background-color: rgba(16,16,26,.5);
    backdrop-filter:blur(20px);
  }
  .childrenTabBar_bg{
    background-color: rgba(16,16,26,.5);
    backdrop-filter:blur(20px);
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue